import {
  Match,
  getMatchDriverTimes,
  getMatchPickSequences,
} from "model/Match/Match";
import {
  statTrackPicksBanRate,
  statTrackPicksPickRate,
} from "../../TrackPickStats";
import {
  statTimesBest,
  statTimesDnfRate,
  statTimesMedian,
} from "stats/TimeStats";

export type SharedTeamTrackStats = {
  teamId: string;
  orgId: string | undefined;
  displayName: string | undefined;
  bestTime: number | undefined;
  medianTime: number | undefined;
  dnfRate: number | undefined;
  dnfBreakdown: string;
  pickRate: number | undefined;
  pickBreakdown: string;
  banRate: number | undefined;
  banBreakdown: string;
};

export const getSharedTeamTrackStats = (
  trackId: string,
  teamId: string,
  orgId: string | undefined,
  displayName: string,
  teamMatches: Match[]
): SharedTeamTrackStats => {
  // todo - on all stats places use this kinda thing?
  // setup these kinda matches getters in a new file for cleaner model files?
  const pickSequences = teamMatches.map(getMatchPickSequences);
  const teamDriverTimes = teamMatches.flatMap((m) =>
    getMatchDriverTimes(m, false, trackId, teamId)
  );

  const { rate: dnfRate, breakdown: dnfBreakdown } =
    statTimesDnfRate(teamDriverTimes);
  const { rate: pickRate, breakdown: pickBreakdown } = statTrackPicksPickRate(
    pickSequences,
    trackId,
    teamId
  );
  const { rate: banRate, breakdown: banBreakdown } = statTrackPicksBanRate(
    pickSequences,
    trackId,
    teamId
  );
  return {
    teamId,
    orgId,
    displayName,
    bestTime: statTimesBest(teamDriverTimes, true),
    medianTime: statTimesMedian(teamDriverTimes),
    dnfRate,
    dnfBreakdown,
    pickRate,
    pickBreakdown,
    banRate,
    banBreakdown,
  };
};
